import { render, staticRenderFns } from "./ArchivedCauselistList.vue?vue&type=template&id=2ed0a6cb"
import script from "./ArchivedCauselistList.vue?vue&type=script&lang=js"
export * from "./ArchivedCauselistList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports